import React, { useRef, useState, useEffect } from "react";
import { Navbar, Button } from "flowbite-react";
import { HiArrowLeft } from "react-icons/hi2";
import { BsThreeDots } from "react-icons/bs";
import { MdCheckCircle } from "react-icons/md";
import letterOfEmploymentImg from "../../../img/letter-of-employment.svg";
import {FaCamera} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { handleLoadLoe, handleLoeUpload } from "./handler";

const EmploymentLetterComponent = (props) => {
  const vehicleLogRef = useRef(null);
  const cssForImageCard = {
    success : {
      imageDiv: 'mt-2 mb-10 custom-card-success border rounded-md items-center shadow-none p-10',
    },
    standard : {
      imageDiv: 'mt-2 mb-10 custom-card border rounded-md items-center shadow-none p-10',
    }
  }
  const selectedProfileType = JSON.parse(sessionStorage.getItem("selectedProfileType"));
  
  let [loePicture, setLoePicture] = useState();
  const navigate = useNavigate();
  let [validation, setValidation] = useState({
    show: false,
    message: "",
    class: "",
  });
  let [userUploadedLoe, setUserUploadedLoe] = useState(false)
  let [loeUploading, setLoeUploading] = useState(false)

  useEffect(() => {
    handleLoadLoe(props.itemIndex, props.memberRequirement.requiredDocuments, setLoePicture, setUserUploadedLoe, letterOfEmploymentImg)
  },[])

  return (
    <>
      <Navbar
        fluid={true}
        rounded={true}
        className="shadow mb-3"
        style={{ position: "fixed", width: "100%", top: "0" }}
      >
        <Navbar.Brand
          onClick={() => {
            props.setOpenUploadDocument({
              openDocument: false,
              documentType: "",
            });
          }}
        >
          <HiArrowLeft className="h-10 w-5 ml-2" />
        </Navbar.Brand>
      </Navbar>
      <div className='p-6  max-w-md m-auto' style={{paddingTop:'80px'}}>
        <h5 className="text-2xl mb-2 font-bold tracking-tight text-gray-900 dark:text-white">
        Letter of Employment
        </h5>
        {/* { validation.show && 
          <div className="error-msg">
            <span>{validation.message}</span>
          </div>
        } */}
        {
          userUploadedLoe && 
          <div class="inline-flex items-center text-base font-semibold text-gray-900 dark:text-white" style={{paddingRight: '10px'}}>
            <MdCheckCircle style = {{ color: '#15BE44' }}/>
          </div>
        }
        <label className='font-bold tracking-tight text-gray-900'>Details</label>
        <div className={ userUploadedLoe ?  cssForImageCard.success.imageDiv : cssForImageCard.standard.imageDiv}>
        {
          validation.show && (
            <div className={validation.class}>
              <span>{validation.message}</span>
            </div>
          )
        }
            <img src={loePicture}
                className="w-auto m-auto"
                alt="Ryde" 
            />
            <p className='text-xs text-gray-400 tracking-tight mt-2'><i>Non-Singaporeans, Upload your letter of employment from a chauffeur company in Singapore.</i></p>
            <Button  pill={true} className='mt-5 m-auto w-sm pr-4' onClick={(e)=>{
                e.preventDefault();
                vehicleLogRef.current.click();
            }}>
            {
              loeUploading ? <BsThreeDots className="h-5 w-10" /> : <FaCamera className="h-5 w-10" />
            }
                <label // for="file-upload"
                className="relative cursor-pointer rounded-md font-medium">
                    <span>{loeUploading ? 'Saving' : userUploadedLoe ? 'Replace' : 'Upload' }</span>
                </label> 
            </Button>
            <input 
                id="file-upload" 
                name="file-upload"
                type="file"
                ref={vehicleLogRef}
                style={{display: 'none', width:'0px'}}
                onChange={async (event) => {
                  await handleLoeUpload(event, setValidation, setLoeUploading, setUserUploadedLoe,
                    "letterOfEmployment", "letterOfEmployment", selectedProfileType.profileId, setLoePicture, navigate, props.memberRequirement, props.setMemberRequirement,props.itemIndex);
                }}
            />
        </div>

        <Button className='bg-primary w-full mt-5' pill={true} disabled={false} 
            onClick={()=>{
              if(userUploadedLoe ) {
                props.setOpenUploadDocument({
                  openDocument: false,
                  documentType: "",
                });
              } else {
                setValidation({
                  show: true,
                  message: "Need to Upload both the sides of the NRIC before submitting for verification",
                  class: "error-msg",
                })
                window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
              }
            }}
        >
            Save
        </Button>
      </div>
    </>
  );
};

export default EmploymentLetterComponent;
